module.exports = "/assets/data/1cef7cbd1391e4f00f685cf276e14749-BT71.data.json";